export default __webpack_public_path__ + "static/676-332d8711fdf742cc6083d544b7c523ad.gif";